import { render, staticRenderFns } from "./AlertPreferences.vue?vue&type=template&id=3e4eaeda&"
import script from "./AlertPreferences.vue?vue&type=script&lang=js&"
export * from "./AlertPreferences.vue?vue&type=script&lang=js&"
import style0 from "./AlertPreferences.vue?vue&type=style&index=0&id=3e4eaeda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports